// extracted by mini-css-extract-plugin
export default {"content":"StaticPage_content__XB5Y7"};